import { useTranslation } from "react-i18next"
import { AlertTriangle } from "lucide-react"
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  Button,
} from "@f2e/ui/components/base"
import { CopilotHiddenField } from "@/components/Copilot/CopilotHiddenField"

interface DeleteConfirmModalProps {
  isOpen: boolean
  onCancel: () => void
  onConfirm: () => void
  selectedCount: number
  loading?: boolean
}

const DeleteConfirmModal = ({
  isOpen,
  onCancel,
  onConfirm,
  selectedCount,
  loading = false,
}: DeleteConfirmModalProps) => {
  const { t, ready } = useTranslation()

  if (!ready) return null

  return (
    <AlertDialog open={isOpen} onOpenChange={onCancel}>
      <AlertDialogContent>
        <CopilotHiddenField
          fieldKey="deleteConfirm.summary"
          value={`selected=${selectedCount}; loading=${loading ? "true" : "false"}`}
        />
        <AlertDialogHeader>
          <div className="flex items-center gap-3">
            <AlertTriangle className="w-6 h-6 text-red-500" />
            <AlertDialogTitle>
              {t("evaluation.evaluationTable.message.deleteConfirmTitle", {
                count: selectedCount,
              })}
            </AlertDialogTitle>
          </div>
          <AlertDialogDescription>
            {t("evaluation.evaluationTable.message.deleteConfirmMessage")}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel asChild>
            <Button variant="outline" onClick={onCancel} disabled={loading}>
              {t("evaluation.evaluationTable.button.cancel")}
            </Button>
          </AlertDialogCancel>
          <AlertDialogAction asChild>
            <Button
              variant="destructive"
              onClick={onConfirm}
              disabled={loading}
            >
              {loading
                ? t("evaluation.evaluationTable.action.deleting")
                : t("evaluation.evaluationTable.action.deleteSelected")}
            </Button>
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}

export default DeleteConfirmModal
